// EmailJS configuration for Nexora Productos contact form
export const EMAILJS_CONFIG = {
  serviceId: "service_681yr5o",
  templateId: "template_kg0kjtd",
  publicKey: "WO5EvnLgfCajcn06a",
};
